export default __webpack_public_path__ + "static/media/presentation.4575f0ff.mp4";